import { useMemo } from 'react';
import { SearchBarEvents, SearchType } from '../constants';

export type TrackEventType = (
  _eventName: string,
  _customAttributes?: object | undefined,
  _overrides?: object | undefined,
  _options?:
    | {
        useFetch?: boolean | undefined;
        fetchOption?: RequestInit | undefined;
      }
    | undefined
) => void;

export type EventData = {
  buildKey: number | null;
  suggestionIndex: number | null;
  suggestionText: string | null;
  suggestionsLength: number | null;
  textEntered: string;
  textSource: SearchType | null;
};

export default function useSearchBarEvents(trackEvent: TrackEventType) {
  return useMemo(
    () => ({
      noResults: (textEntered: string) => {
        trackEvent(SearchBarEvents.NoResults, { textEntered });
      },
      focused: () => {
        trackEvent(SearchBarEvents.Focused);
      },
      removeRecentSearch: () => {
        trackEvent(SearchBarEvents.RemovedRecentSearch, {
          removedType: 'Single'
        });
      },
      suggestionClicked: (eventData: EventData) => {
        trackEvent(SearchBarEvents.SuggestionClicked, eventData);
      },
      goClicked: (eventData: EventData) => {
        trackEvent(SearchBarEvents.GoClicked, eventData);
      },
      pressedEnter: (eventData: EventData) => {
        trackEvent(SearchBarEvents.PressedEnter, eventData);
      }
    }),
    [trackEvent]
  );
}
